import Segmente from "./Segmente";
import { v3, quat } from "oc-threejs/short3";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";


export default class Waeschesack extends Segmente {

    constructor(vsData) {
        super(vsData);
        this.parts = [
            {
                obj: APP.findProduct('Waeschesack')?.objName,
                origin: v3(0.5, 0, 0.5),
                quaternion: quat(0, 1, 0, 90),
                valid: {
                    achsis: "x",
                    tallerThan: 35,
                    smallerThan: 75
                },
            },
            {
                obj: APP.findProduct('Waeschesack_900mm')?.objName,
                origin: v3(0.5, 0, 0.5),
                quaternion: quat(0, 1, 0, 90),
                valid: {
                    achsis: "x",
                    tallerThan: 75,
                    smallerThan: 85
                },
            },
            {
                obj: APP.findProduct('Waeschesack_1000mm')?.objName,
                origin: v3(0.5, 0, 0.5),
                quaternion: quat(0, 1, 0, 90),
                valid: {
                    achsis: "x",
                    tallerThan: 85,
                    smallerThan: Infinity
                },
            },
        ]

    }

    vsUpdate(force = false) {
        super.vsUpdate();
        if (this.isVsChanged('size') || this.isVsChanged('flipSide') || force) {
                Scenes.remove(this.relingHinten);
                Scenes.remove(this.relingVorne);
                this.relingHinten = this.createReling();
                this.updateReling(this.relingHinten, v3(0.5, 0.95, 0.1));
                this.relingVorne = this.createReling();
                this.updateReling(this.relingVorne, v3(0.5, 0.95, 0.9))
        }
    }

    createReling() {
        const y = 2;
        const z = 0.8
        const material = UniversalLoader.getMaterialFactory().create("CHROM_MATT");
        let stange;
        stange = new THREE.Mesh(
            new THREE.BoxGeometry(100, y, z),
            material
        );
        stange.geometry.dynamic = true;
        stange.castShadow = true;
        stange.receiveShadow = true;
        return stange;
    }

    updateReling(stange, position) {
        this.boxLocalO3.add(stange);
        stange.scale.setX(this.vsData.size.x / 100);
        const to = this.vsData.boxLocal.grid(position);
        stange.position.add(to);
    }

}